import { takeLatest, put } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';
import {
  FEEDBACK_QUESTION_TYPES_66,
  FEEDBACK_HOT_66,
  FEEDBACK_HOT_DELETE_66,
  FEEDBACK_RECORDS_66,
} from '../config';
import {
  SET_FEEDBACK_RECORDS,
  GET_FEEDBACK_RECORDS,
  GET_FEEDBACK_QUESTION_TYPES,
  SET_FEEDBACK_QUESTION_TYPES,
} from '../constants/userFeedback';

// 获取用户反馈记录
function* fetchFeedbackRecords() {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FEEDBACK_RECORDS_66);
    yield put({
      type: SET_FEEDBACK_RECORDS,
      payload: res.data.status === 0 ? (res.data.data && res.data.data.feedbackRecords) || [] : [],
    });
  } catch (error) {
    logNative('获取用户反馈记录失败 fetchFeedbackRecords', error);
  }
}

export function* watchFetchFeedbackRecords() {
  yield takeLatest(GET_FEEDBACK_RECORDS, fetchFeedbackRecords);
}

// 获取问题类型
function* fetchFeedbackQuestionTypes() {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(FEEDBACK_QUESTION_TYPES_66);
    if (res.data.status === 0) {
      yield put({
        type: SET_FEEDBACK_QUESTION_TYPES,
        payload: (res.data.data && res.data.data.feedbackTypeList) || [],
      });
    }
  } catch (error) {
    logNative('获取反馈问题类型失败 fetchFeedbackQuestionTypes', error);
  }
}

export function* watchFetchFeedbackQuestionTypes() {
  yield takeLatest(GET_FEEDBACK_QUESTION_TYPES, fetchFeedbackQuestionTypes);
}
